import { ReactNode } from 'react'
import { motion } from 'motion/react'
import { ScrollArea } from '@/components/shadcn/scroll-area'

export function ContentPanel({ children }: { children: ReactNode }) {
  return (
    <ScrollArea className="h-full flex-1">
      <motion.div layout className="relative flex w-full grid-cols-6 flex-col bg-background px-5">
        {children}
      </motion.div>
    </ScrollArea>
  )
}
